export const OFFPLAN_BUY_SELL_LOADING = 'OFFPLAN_BUY_SELL_LOADING';
export const OFFPLAN_BUY_SELL_SUCCESS = 'OFFPLAN_BUY_SELL_SUCCESS';
export const OFFPLAN_BUY_SELL_ERROR = 'OFFPLAN_BUY_SELL_ERROR';
export const OFFPLAN_BUY_SELL_CLEAR_ERROR = 'OFFPLAN_BUY_SELL_CLEAR_ERROR';
export const OFFPLAN_BUY_SELL_CLEAR_APPLICATION = 'OFFPLAN_BUY_SELL_CLEAR_APPLICATION';

export const OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_SUCCESS = 'OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_SUCCESS';

export const OFFPLAN_BUY_SELL_FETCH_APPLICATION_DETAILS_SUCCESS = 'OFFPLAN_BUY_SELL_FETCH_APPLICATION_DETAILS_SUCCESS';

export const OFFPLAN_BUY_SELL_DELETE_BROKER_SUCCESS = 'OFFPLAN_BUY_SELL_DELETE_BROKER_SUCCESS';

export const OFFPLAN_BUY_SELL_ADD_BUYER_SUCCESS = 'OFFPLAN_BUY_SELL_ADD_BUYER_SUCCESS';

export const OFFPLAN_BUY_SELL_SET_BUYER_TRANSACTION_PERCENTAGE = 'OFFPLAN_BUY_SELL_SET_BUYER_TRANSACTION_PERCENTAGE';

export const OFFPLAN_BUY_SELL_CHANGE_WORKFLOW_STEP = 'OFFPLAN_BUY_SELL_CHANGE_WORKFLOW_STEP';

export const OFFPLAN_BUY_SELL_SAVE_APPLICATION_SUCCESS = 'OFFPLAN_BUY_SELL_SAVE_APPLICATION_SUCCESS';

export const OFFPLAN_BUY_SELL_FETCH_DOCUMENTS_SUCCESS = 'OFFPLAN_BUY_SELL_FETCH_DOCUMENTS_SUCCESS';
export const OFFPLAN_BUY_SELL_FETCH_BREAKDOWN_SUCCESS = 'OFFPLAN_BUY_SELL_FETCH_BREAKDOWN_SUCCESS';
export const RESET_BREAKDOWN_SUCCESS = 'RESET_BREAKDOWN_SUCCESS';

export const OFFPLAN_BUY_SELL_FIELD_CHANGE = 'OFFPLAN_BUY_SELL_FIELD_CHANGE';
export const OFFPLAN_BUY_SELL_FORM_ERROR = 'OFFPLAN_BUY_SELL_FORM_ERROR';

export const OFFPLAN_BUY_SELL_FETCH_GOVERNMENT_COMPANIES_SUCCESS =
  'OFFPLAN_BUY_SELL_FETCH_GOVERNMENT_COMPANIES_SUCCESS';

export const OFFPLAN_BUY_SELL_CLEAR_GOVERNMENT_COMPANIES = 'OFFPLAN_BUY_SELL_CLEAR_GOVERNMENT_COMPANIES';

export const OFFPLAN_BUY_SELL_FETCH_NON_UAE_USERS = 'OFFPLAN_BUY_SELL_FETCH_NON_UAE_USERS';
export const OFFPLAN_BUY_SELL_FETCH_NON_UAE_USERS_SUCCESS = 'OFFPLAN_BUY_SELL_FETCH_NON_UAE_USERS_SUCCESS';

// --------------- previous work ------------- //

export const INITIATE_OFFPLAN_APPLICATION = 'INITIATE_OFFPLAN_APPLICATION';
export const INITIATE_OFFPLAN_APPLICATION_ERROR = 'INITIATE_OFFPLAN_APPLICATION_ERROR';

export const FETCH_APPLICATION_OFFPLAN = 'FETCH_APPLICATION_OFFPLAN';
export const FETCH_APPLICATION_OFFPLAN_SUCCESS = 'FETCH_APPLICATION_OFFPLAN_SUCCESS';
export const FETCH_APPLICATION_OFFPLAN_ERROR = 'FETCH_APPLICATION_OFFPLAN_ERROR';

export const SET_CONTRACT_DETAILS = 'SET_CONTRACT_DETAILS';
export const SET_BUYER_DETAIL = 'SET_BUYER_DETAIL';

export const FETCH_OFFPLAN_BUYER = 'FETCH_OFFPLAN_BUYER';
export const FETCH_OFFPLAN_BUYER_SUCCESS = 'FETCH_OFFPLAN_BUYER_SUCCESS';
export const FETCH_OFFPLAN_BUYER_ERROR = 'FETCH_OFFPLAN_BUYER_ERROR';

export const DELETE_OFFPLAN_BUYER = 'DELETE_OFFPLAN_BUYER';
export const DELETE_OFFPLAN_BUYER_SUCCESS = 'DELETE_OFFPLAN_BUYER_SUCCESS';
export const DELETE_OFFPLAN_BUYER_ERROR = 'DELETE_OFFPLAN_BUYER_ERROR';

export const FETCH_OFFPLAN_POA = 'FETCH_OFFPLAN_POA';
export const FETCH_OFFPLAN_POA_SUCCESS = 'FETCH_OFFPLAN_POA_SUCCESS';
export const FETCH_OFFPLAN_POA_ERROR = 'FETCH_OFFPLAN_POA_ERROR';

export const ADD_OFFPLAN_POA = 'ADD_OFFPLAN_POA';
export const ADD_OFFPLAN_POA_SUCCESS = 'ADD_OFFPLAN_POA_SUCCESS';
export const ADD_OFFPLAN_POA_ERROR = 'ADD_OFFPLAN_POA_ERROR';

export const DELETE_OFFPLAN_POA = 'DELETE_OFFPLAN_POA';
export const DELETE_OFFPLAN_POA_SUCCESS = 'DELETE_OFFPLAN_POA_SUCCESS';
export const DELETE_OFFPLAN_POA_ERROR = 'DELETE_OFFPLAN_POA_ERROR';

export const SAVE_INSTALLMENT_PLAN = 'SAVE_INSTALLMENT_PLAN';
export const SAVE_INSTALLMENT_PLAN_SUCCESS = 'SAVE_INSTALLMENT_PLAN_SUCCESS';
export const SAVE_INSTALLMENT_PLAN_ERROR = 'SAVE_INSTALLMENT_PLAN_ERROR';

export const DELETE_INSTALLMENT_PLAN = 'DELETE_INSTALLMENT_PLAN';
export const DELETE_INSTALLMENT_PLAN_SUCCESS = 'DELETE_INSTALLMENT_PLAN_SUCCESS';
export const DELETE_INSTALLMENT_PLAN_ERROR = 'DELETE_INSTALLMENT_PLAN_ERROR';

export const SAVE_APPLICATION_OFFPLAN = 'SAVE_APPLICATION_OFFPLAN';
export const SAVE_APPLICATION_OFFPLAN_ERROR = 'SAVE_APPLICATION_OFFPLAN_ERROR';

export const FETCH_OFFPLAN_PAYMENT_BREAKDOWN = 'FETCH_OFFPLAN_PAYMENT_BREAKDOWN';
export const FETCH_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS = 'FETCH_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS';
export const FETCH_OFFPLAN_PAYMENT_BREAKDOWN_ERROR = 'FETCH_OFFPLAN_PAYMENT_BREAKDOWN_ERROR';

export const OFFPLAN_VALIDATION_ERROR = 'OFFPLAN_VALIDATION_ERROR';

export const DOWNLOAD_DOCUMENT_MUSATAHA = 'DOWNLOAD_DOCUMENT_MUSATAHA';
export const DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS = 'DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS';
export const DOWNLOAD_DOCUMENT_MUSATAHA_ERROR = 'DOWNLOAD_DOCUMENT_MUSATAHA_ERROR';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';
export const ADD_TO_ERROR_INITITATE = 'ADD_TO_ERROR_INITITATE';

export const UPLOAD_MUSATAHA_DOCUMENT = 'UPLOAD_MUSATAHA_DOCUMENT';
export const UPLOAD_MUSATAHA_DOCUMENT_SUCCESS = 'UPLOAD_MUSATAHA_DOCUMENT_SUCCESS';
export const UPLOAD_MUSATAHA_DOCUMENT_ERROR = 'UPLOAD_MUSATAHA_DOCUMENT_ERROR';

export const CHECKOUT_MUSATAHA_APPLICATION = 'CHECKOUT_MUSATAHA_APPLICATION';
export const CHECKOUT_MUSATAHA_APPLICATION_SUCCESS = 'CHECKOUT_MUSATAHA_APPLICATION_SUCCESS';
export const CHECKOUT_MUSATAHA_APPLICATION_ERROR = 'CHECKOUT_MUSATAHA_APPLICATION_ERROR';

export const MUSATAHA_CANCEL_APPLICATION = 'MUSATAHA_CANCEL_APPLICATION';
export const MUSATAHA_CANCEL_APPLICATION_SUCCESS = 'MUSATAHA_CANCEL_APPLICATION_SUCCESS';
export const MUSATAHA_CANCEL_APPLICATION_ERROR = 'MUSATAHA_CANCEL_APPLICATION_ERROR';

export const MUSATAHA_CHANGE_APPLICATION_STEP = 'MUSATAHA_CHANGE_APPLICATION_STEP';
